<template>
  <div
    ref="nav"
    class="nav-compo"
  >
    <div class="item-view flx-row-str">
      <div
        v-for="(item, index) in navInfo"
        :id="`nav-${item.name}`"
        :key="`nav-${index}`"
        class="icon-view flx-ctr"
        :style="{minWidth:`${100 / (navInfo.length)}%`}"
        @click="navChange(item.name)"
      >
        <van-image
          :src="activeNav === item.name ? item.hIcon : item.nIcon"
          :width="activeNav === item.name ? `${item.width}px` : `${item.nWidth || item.width}px`"
          :height="activeNav === item.name ? `${item.height}px` : `${item.nHeight || item.height}px`"
          :show-error="false"
          :show-loading="false"
          class="icon"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    navInfo: {
      type: Array,
      default() {
        return [];
      },
    },
    activeNav: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    navChange(name) {
      this.$emit('navChange', name);
    },
  },
};
</script>

<style lang="less" scoped>
.nav-compo {
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .item-view {
    height: 100%;
    white-space: nowrap;
    .icon-view {
      flex-shrink: 0;
      height: 100%;
      width: 77px;
    }
    .icon {
    }
  }
}
</style>
